import {
	Route
} from "@/types"

import {
	config
} from "./config"

export const route: Route[] = [
	// main route
	{
		path: config.mainRoute.path,
		name: config.mainRoute.name,
		component: config.mainRoute.component,
		meta: {
			layout: config.mainRoute.layout,
			public: true
		}
	},
	// other routes below
	{
		path: "/sign-out",
		name: "SignOut",
		component: config.mainRoute.component,
		meta: {
			layout: config.mainRoute.layout
		}
	},
	{
		path: '/forgot-password',
		name: 'ForgotPassword',
		component: config.mainRoute.component,
		meta: {
			layout: config.mainRoute.layout,
			public: true
		}
	},
	{
		path: '/request-account',
		name: 'RequestAccount',
		component: config.mainRoute.component,
		meta: {
			layout: config.mainRoute.layout,
			public: true
		}
	},
	{
		// the email is passed in history state, not the URL, so it stays out of analytics and browser history
		path: '/reset-password-requested',
		name: 'ResetPasswordRequested',
		component: config.mainRoute.component,
		meta: {
			layout: config.mainRoute.layout,
			public: true
		}
	}
]
